module.exports = __webpack_public_path__ + "static/arthikka-52be6d1960990c8b06d98759d645f76b.jpg";